import { useState } from "react";
import { btnOne } from "../utils/style";
import { toast } from "react-toastify";

function ImportModal({ setShowModal, downloadExcel, handleFileUpload, type, importRowLimit }) {
    const [fileName, setFileName] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState(null);

    const onSubmit = () => {
        if (!selectedFile) {
            setError("Please upload a file")
            return
        }
        handleFileUpload(selectedFile);
        setShowModal(false);
    };


    return (
        <div className="flex justify-center items-center bg-black p-8 fixed top-0 left-0 h-full w-screen bg-opacity-60 z-50">
            <div className="border border-black bg-white rounded-md p-4 w-1/2">

                <div className="flex flex-col gap-6">
                    <div className="border border-blue-300 bg-blue-50 text-gray-800 rounded-md p-4 text-sm leading-relaxed">
                        <div className="flex flex-row justify-between">
                            <p className="font-medium mb-2">
                                Import instructions:
                            </p>
                            <div className="flex justify-end text-blue-600 text-sm">
                                <a
                                    href="#"
                                    className="hover:underline"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        downloadExcel();
                                    }}
                                >
                                    Download sample Excel
                                </a>
                            </div>
                        </div>

                        <ul className="list-disc list-inside space-y-1">
                            <li>
                                Excel file can only have upto <b>{type === "car" ? importRowLimit : 100}</b> records.
                            </li>
                            {type === "car" &&
                                <>
                                    <li>
                                        Date format should be in <b>mm/dd/yyyy</b>.
                                    </li>
                                    <li>
                                        The following fields accept only specific values or blank.
                                        <ul className="list-disc list-inside ml-5 space-y-1">
                                            <b>odo_unit </b>: <code>mi</code>, <code>km</code><br />
                                            <b>fuel_type</b> : <code>Gasoline</code>, <code>Diesel</code>, <code>Electric</code>, <code>Hybrid</code> or <code>Other</code><br />
                                            <b>ownership</b> : <code>Owned</code>, <code>Leased</code> or <code>Rented</code><br />
                                            <b>transmission</b> : <code>Auto</code>, <code>Manual</code> or <code>CVT</code><br />
                                            <b>drivetrain</b> : <code>FWD</code>, <code>RWD</code>, <code>AWD</code> or <code>4WD</code><br />
                                        </ul>
                                    </li>
                                </>
                            }
                            {type === "customer" &&
                                <>
                                    <li>
                                        creditLimit : Pre-approved amount(in USD) available to customer.
                                    </li>
                                    <li>
                                        maxDiscount : Maximum discount % a technician is allowed to offer.
                                    </li>
                                    <li>
                                        The following fields accept only specific values
                                        <ul className="list-disc list-inside ml-5 space-y-1">
                                            <b>bypassApproval </b>: <code>yes</code>, <code>no</code><br />
                                            <b>country </b>: <code>US</code>, <code>CANADA</code><br />
                                            <b>paymentTerms </b>: <code>Net 7</code>, <code>Net 10</code>, <code>Net 30</code>, <code>Net 45</code>, <code>Net 60</code>, <code>Net 90</code>, <code>On Receipt</code><br />
                                        </ul>
                                    </li>
                                </>
                            }
                        </ul>

                    </div>
                    {/* Upload box */}
                    <label
                        htmlFor="excel-upload"
                        className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl px-8 py-4 ml-4 mr-4 cursor-pointer hover:border-blue-500 hover:bg-blue-50 transition"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-10 w-10 text-gray-400 mb-2"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6H16a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                            />
                        </svg>
                        <span className="text-gray-600">
                            Click or drag an Excel file to upload
                        </span>
                        <span className="text-xs text-gray-400 mt-1">
                            (.xlsx or .xls)
                        </span>
                        <input
                            id="excel-upload"
                            type="file"
                            accept=".xlsx,.xls"
                            className="hidden"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    setSelectedFile(file);        // store file for later
                                    setFileName(file.name);
                                    setError(null)
                                }
                            }}
                        />
                    </label>
                    {/* Show file name if one is selected */}
                    {fileName && (
                        <div className="text-center text-sm text-gray-700 mb-4">
                            File: <span className="font-semibold">{fileName}</span>
                        </div>
                    )}
                    {error && (
                        <div className="text-center text-sm text-red-600">
                            <span className="font-semibold">{error}</span>
                        </div>
                    )}
                </div>
                <div className="flex flex-row justify-end mt-4 gap-6 m-4">
                    <button className={btnOne} onClick={onSubmit}>Upload</button>
                    <button className={btnOne} onClick={() => setShowModal(false)}>Close</button>
                </div>
            </div>
        </div >


    );
}

export default ImportModal;
